<template>
  <div class="may-like" :class="{en: $i18n.locale === 'en'}">
    <span class="may-like-triangle"></span>
    <span class="may-like-text">{{ $t('main.YOU_MAY_LIKE') }}</span>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="css" scoped>
.may-like {  
  height: 25px;
  width: 65px;
  position: relative;
  font-size: 0px;
}

.may-like.en {
  width: 107px;
}

.may-like-triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 15px 25px 0;
  border-color: transparent transparent #fee032 transparent;
  position: absolute;
  top: 0;
  left: 50px;
}

.may-like.en > .may-like-triangle {
  left: 102px;
}

.may-like-text {
  background-color: #fee032;
  font-size: 15px;
  line-height: 25px;
  position: absolute;
  top: 0;
  left: px;
  padding: 0 10px;
  font-weight: 700;
  white-space: nowrap;
}

</style>